import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.to-string.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Modal from '@mozaic-ds/freemarker/js/modules/_modal.js';
import { Store } from '@adeo/kobi--front-helpers';
import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
import { ENERGY_RENOVATION_DB_VERSION, TOTAL_INFO } from './subcomponents/energy/constants';
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import { getTmsInstance } from 'integration-web-core--socle/js/assets/commons/_tms.js';
import { handleJsonLdScripts } from './lib/json-ld';
import { addTrackingButton } from './lib/buttonsTraking';
import TabManager from './lib/tab-manager';
import { getCookie } from './lib/cookie-utils';
import { isStorePocEligible, getStorePageUrl } from './lib/poc-store-context';
var ServicesLeadPage = /*#__PURE__*/function (_lm$Composant) {
  function ServicesLeadPage(id) {
    var _this;
    _classCallCheck(this, ServicesLeadPage);
    _this = _callSuper(this, ServicesLeadPage, [id]);
    _this.myComponent = document.querySelector('.component-servicesleadpage');
    _this.pagename = _this.myComponent.querySelector('h1').innerHTML;
    _this.leadType = '';
    var segmentedTabs = document.querySelector('.js-segmented-tabs');
    var stepCarouselGuarantees = document.getElementById('carousel-steps-guarantees');
    _this.eligibilityContext();
    if (stepCarouselGuarantees) {
      try {
        new Carousel(stepCarouselGuarantees);
      } catch (error) {
        console.error("error initializing guarantees carousel: ".concat(error));
      }
    }
    if (segmentedTabs) {
      TabManager.manageTabs('#tabGuarentee', '#tabBudget');
      var budgetTab = document.getElementById('tabBudget');
      var budgetCarouselInitialized = false;
      if (budgetTab) {
        budgetTab.addEventListener('click', function () {
          if (!budgetCarouselInitialized) {
            var stepCarouselBudget = document.getElementById('carousel-steps-budget');
            if (stepCarouselBudget) {
              try {
                new Carousel(stepCarouselBudget);
                budgetCarouselInitialized = true;
              } catch (error) {
                console.error("error initializing budget carousel: ".concat(error));
              }
            }
          }
        });
      }
    }
    _this.myAccordions = _this.myComponent.querySelectorAll('.js-accordion');
    if (_this.myAccordions) {
      _this.loadAccordion();
    }
    var buttonNext = _this.target.querySelector('.js-openPopin');
    if (buttonNext) {
      buttonNext.addEventListener('click', function (event) {
        var buttonlabel = event.target.querySelector('span').innerHTML;
        _this.sendTracking(buttonlabel);
      });
    }
    _this.pushLinkButtons = _this.myComponent.querySelectorAll('.js-pushs-link');
    if (_this.pushLinkButtons) {
      var _iterator = _createForOfIteratorHelper(_this.pushLinkButtons),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pushLinkButton = _step.value;
          pushLinkButton.addEventListener('click', function (event) {
            var cardname = event.target.dataset.cardname;
            _this.sendTracking(cardname);
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    _this.summaryLeadtrackingButtons = _this.myComponent.querySelectorAll('.js-lead-summary-tracking');
    if (_this.summaryLeadtrackingButtons) {
      var _iterator2 = _createForOfIteratorHelper(_this.summaryLeadtrackingButtons),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var summaryLeadtrackingButton = _step2.value;
          summaryLeadtrackingButton.addEventListener('click', function (event) {
            var _event$target$dataset = event.target.dataset,
              buttonName = _event$target$dataset.buttonName,
              buttonLocation = _event$target$dataset.buttonLocation;
            var trackingObj = {
              event_name: 'button.click',
              event_data: {
                'button_location': "".concat(buttonLocation),
                'button_name': "".concat(buttonName)
              }
            };
            getTmsInstance().pushEvent(document, 'cdl_event', trackingObj);
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    addTrackingButton(_this.myComponent);
    window.addEventListener('DOMContentLoaded', handleJsonLdScripts);
    _this.initOldDataManagement();

    // Seo Zone
    var seoZone = document.querySelector('.js-zone-seo');
    if (seoZone) {
      _this.btnMoreChapter = seoZone.querySelector('.js-more-chapter');
      _this.btnLessChapter = seoZone.querySelector('.js-less-chapter');
      _this.seoChapters = seoZone.querySelector('.js-chapters');
      if (_this.btnMoreChapter) {
        _this.btnMoreChapter.addEventListener('click', function (e) {
          e.preventDefault();
          _this.loadMoreChapters();
        });
      }
      if (_this.btnLessChapter) {
        _this.btnLessChapter.addEventListener('click', function (e) {
          e.preventDefault();
          _this.loadLessChapters();
        });
      }
    }
    return _this;
  }
  _inherits(ServicesLeadPage, _lm$Composant);
  return _createClass(ServicesLeadPage, [{
    key: "eligibilityContext",
    value: function eligibilityContext() {
      var _ref, _customerContext$main, _customerContext, _exec;
      var fromCustomerContextCookie = getCookie('customer_context');
      var fromStoreCookie = getCookie('store');
      var fallbackStoreId = getCookie('store_id');
      var customerContext;
      try {
        customerContext = fromCustomerContextCookie ? JSON.parse(decodeURIComponent(fromCustomerContextCookie)) : null;
      } catch (_unused) {
        customerContext = null;
      }
      var storeId = (_ref = (_customerContext$main = (_customerContext = customerContext) === null || _customerContext === void 0 ? void 0 : _customerContext.main_store) !== null && _customerContext$main !== void 0 ? _customerContext$main : (_exec = /store=(\d+)/.exec(fromStoreCookie !== null && fromStoreCookie !== void 0 ? fromStoreCookie : '')) === null || _exec === void 0 ? void 0 : _exec[1]) !== null && _ref !== void 0 ? _ref : fallbackStoreId;
      var resolvedStoreId = storeId ? String(storeId) : undefined;

      // POC Store Context: contextualiser le bouton si on est sur une page POC_CONTEXT
      this.applyPocStoreContext(resolvedStoreId);
      return resolvedStoreId;
    }

    /**
     * POC Store Context - Contextualisation du bouton CTA
     * POC fin prévue : 31/08/2026 - Code à supprimer après cette date
     *
     * Cas :
     * 1. Magasin dans le POC → boutons affichés tels quels
     * 2. Magasin hors POC → masquer boutons originaux, afficher "Voir la fiche magasin"
     * 3. Pas de magasin → rien (boutons masqués)
     */
  }, {
    key: "applyPocStoreContext",
    value: function applyPocStoreContext(storeId) {
      var leadType = this.myComponent.dataset.leadtype;
      if (leadType !== 'POC_CONTEXT') {
        return;
      }
      var notification = this.myComponent.querySelector('.js-poc-store-notification');
      if (notification && !isStorePocEligible(storeId)) {
        notification.classList.remove('kl-hidden');
      }
      if (storeId && isStorePocEligible(storeId)) {
        this.showPocEligibleButtons();
      } else if (storeId) {
        this.showStorePageButtons(storeId);
      } else {
        this.hidePocSkeletonButton();
      }
    }
  }, {
    key: "showPocEligibleButtons",
    value: function showPocEligibleButtons() {
      var mainCta = this.myComponent.querySelector('.js-poc-main-cta');
      var skeletonCta = document.querySelector('.js-poc-skeleton-cta');
      if (mainCta) mainCta.classList.remove('kl-hidden');
      if (skeletonCta) skeletonCta.classList.remove('kl-hidden');
    }
  }, {
    key: "showStorePageButtons",
    value: function showStorePageButtons(storeId) {
      var storePageUrl = getStorePageUrl(storeId);
      if (!storePageUrl) {
        this.hidePocSkeletonButton();
        return;
      }
      var storeCta = this.myComponent.querySelector('.js-poc-store-cta');
      var skeletonCta = document.querySelector('.js-poc-skeleton-cta');
      var skeletonStoreCta = document.querySelector('.js-poc-skeleton-store-cta');
      if (storeCta) {
        var link = storeCta.querySelector('a');
        if (link) link.setAttribute('href', storePageUrl);
        storeCta.classList.remove('kl-hidden');
      }
      if (skeletonCta) skeletonCta.classList.add('kl-hidden');
      if (skeletonStoreCta) {
        var _link = skeletonStoreCta.querySelector('a');
        if (_link) _link.setAttribute('href', storePageUrl);
        skeletonStoreCta.classList.remove('kl-hidden');
      }
    }
  }, {
    key: "hidePocSkeletonButton",
    value: function hidePocSkeletonButton() {
      var skeletonCta = document.querySelector('.js-poc-skeleton-cta');
      if (skeletonCta) skeletonCta.classList.add('kl-hidden');
    }

    // Méthode d'initialisation des données (Appels asynchrones ici)
  }, {
    key: "initOldDataManagement",
    value: function initOldDataManagement() {
      var _this2 = this;
      if (document.querySelector('.js-modal-old-data')) {
        this.indexDBStore = new Store('EnergyRenovationDB', ENERGY_RENOVATION_DB_VERSION);
        this.indexDBStore.values().then(function (userInfos) {
          if (TOTAL_INFO.includes(userInfos.length)) {
            var sectionLead = document.querySelector('.js-section-leadpage');
            _this2.leadType = sectionLead.dataset['leadtype'];
            _this2.indexDBStore.set('leadType', {
              name: 'leadType',
              value: _this2.leadType
            })["catch"](function (err) {
              return console.error(err);
            });
            userInfos = userInfos.map(function (x) {
              if (x.name === 'leadType') {
                x.value = _this2.leadType;
              }
              return x;
            });
            _this2.setupModalEvents(userInfos);
          }
        })["catch"](function (err) {
          return console.error(err);
        });
        this.modal = new Modal({
          classContent: 'js-modal-old-data'
        });
      }
    }
  }, {
    key: "setupModalEvents",
    value: function setupModalEvents(userInfos) {
      var _this3 = this;
      this.target.querySelector('.js-openPopin').addEventListener('click', function (event) {
        event.preventDefault();
        _this3.modal.open();
        _this3.target.querySelector('.js-restart-modal').addEventListener('click', function () {
          return _this3.handleRestartModal();
        });
        _this3.target.querySelector('.js-valid-modal').addEventListener('click', function () {
          var form = document.createElement('form');
          form.setAttribute('action', '/services/energyrenovationapp/submit');
          form.setAttribute('method', 'POST');
          var _iterator3 = _createForOfIteratorHelper(userInfos),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _step3.value,
                name = _step3$value.name,
                value = _step3$value.value;
              _this3.createInputHidden(name, value, form);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          _this3.target.insertAdjacentElement('afterbegin', form);
          form.submit();
        });
      });
    }
  }, {
    key: "handleRestartModal",
    value: function handleRestartModal() {
      var _this4 = this;
      this.indexDBStore.keys().then(function (keys) {
        var deletePromises = keys.map(function (key) {
          return _this4.indexDBStore["delete"](key);
        });
        return Promise.all(deletePromises);
      }).then(function () {
        location.href = "/servicesleadpage/services/energyrenovationapp?leadType=".concat(_this4.leadType);
      })["catch"](function (err) {
        return console.error('Error clearing DB:', err);
      });
    }
  }, {
    key: "loadAccordion",
    value: function loadAccordion() {
      var _iterator4 = _createForOfIteratorHelper(this.myAccordions),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var accordion = _step4.value;
          try {
            new Accordion(accordion);
          } catch (error) {
            console.error("error ".concat(error));
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "createInputHidden",
    value: function createInputHidden(name, value, target) {
      target.insertAdjacentHTML('afterbegin', "<input type=\"hidden\" name=\"".concat(name, "\" value=\"").concat(value, "\"/>"));
    }
  }, {
    key: "sendTracking",
    value: function sendTracking(buttonlabel) {
      var trackingObj = {
        event_name: 'button.click',
        event_data: {
          'button_value': "".concat(this.pagename.trim()),
          'button_type': 'service',
          'button_name': "".concat(buttonlabel.trim())
        }
      };
      getTmsInstance().pushEvent(document, 'cdl_event', trackingObj);
    }
  }, {
    key: "loadMoreChapters",
    value: function loadMoreChapters() {
      this.seoChapters.classList.remove('is-blurred');
      this.btnLessChapter.classList.remove('kl-hidden');
      this.btnMoreChapter.classList.add('kl-hidden');
    }
  }, {
    key: "loadLessChapters",
    value: function loadLessChapters() {
      this.seoChapters.classList.add('is-blurred');
      this.btnMoreChapter.classList.remove('kl-hidden');
      this.btnLessChapter.classList.add('kl-hidden');
      document.querySelector('.js-zone-seo').scrollIntoView();
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  try {
    new ServicesLeadPage('servicesleadpage');
  } catch (error) {
    console.error("error ".concat(error));
  }
});
export default ServicesLeadPage;